export default function ScrollToTop() {

    window.scroll({
        top: 0,
        behavior: 'smooth'
    })
}